import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabaseClient';

const BASE = [
  { icon:'🕊️', group_name:'Sunday Worship', sub_title:'Every Sunday', is_accent:false, items:[{t:'06:30 AM',n:'Service 1 — Morning Worship'},{t:'09:30 AM',n:'Service 2 — Main Worship'}] },
  { icon:'⚡', group_name:'Zion Royal Youth', sub_title:'Sunday Youth Service', is_accent:false, items:[{t:'12:00 PM',n:'Youth Service — Sunday'}] },
  { icon:'👶', group_name:'Zion Royal Kids', sub_title:"Children's Church", is_accent:false, items:[{t:'07:30 AM',n:'Kids Church — with Service 1'},{t:'10:30 AM',n:'Kids Church — with Service 2'}] },
  { icon:'🙏', group_name:'Daily Prayer', sub_title:'365 Days a Year', is_accent:true, items:[{t:'10:00 AM',n:'Church Prayer — Every Single Day'}] },
  { icon:'🔥', group_name:'Deliverance Prayer', sub_title:'2nd Week Sat & Sun', is_accent:false, items:[{t:'06:30 PM',n:'2nd Week — Saturday & Sunday'}] },
  { icon:'⭐', group_name:'Special Fasting Prayer', sub_title:'Last Week of Month', is_accent:false, items:[{t:'05:00 AM',n:'Last Week Mon–Sat — Morning'},{t:'10:30 AM',n:'Last Week Mon–Sat — Midday'},{t:'06:00 PM',n:'Last Week Mon–Sun — Evening'}] },
  { icon:'🌅', group_name:'New Month Prayer', sub_title:'Every 1st of the Month', is_accent:true, items:[{t:'05:00 AM',n:'Early Morning Prayer — 1st of Every Month'}] },
];

export default function Services() {
  const [groups, setGroups] = useState(BASE);

  useEffect(() => {
    let cancelled = false;
    supabase.from('service_times').select('*').order('display_order', { ascending: true })
      .then(({ data }) => {
        if (!cancelled && data && data.length > 0) {
          setGroups(data.map(g => ({ ...g, items: typeof g.items === 'string' ? JSON.parse(g.items) : g.items })));
        }
      }).catch(() => {});
    return () => { cancelled = true; };
  }, []);

  return (
    <section id="services" className="section" style={{ background: 'linear-gradient(180deg,var(--bg-deep) 0%,var(--bg-dark) 100%)' }}>
      <div className="container">
        <div style={{ textAlign: 'center' }}>
          <span className="section-tag">✦ Come Worship With Us</span>
          <h2 className="section-title">Service <span>Times</span></h2>
          <div className="divider center" />
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(290px,1fr))', gap: 18 }}>
          {groups.map((grp, i) => (
            <div key={i} className="fade-up" style={{ background:'var(--card-bg)', border:`1px solid ${grp.is_accent?'rgba(201,168,76,0.45)':'var(--card-border)'}`, borderRadius:16, overflow:'hidden', transition:'all 0.3s' }}
              onMouseEnter={e => { e.currentTarget.style.borderColor='var(--primary)'; e.currentTarget.style.boxShadow='0 12px 40px rgba(0,0,0,0.4)'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor=grp.is_accent?'rgba(201,168,76,0.45)':'var(--card-border)'; e.currentTarget.style.boxShadow='none'; }}
            >
              <div style={{ background:grp.is_accent?'linear-gradient(135deg,rgba(201,168,76,0.22),rgba(178,34,34,0.15))':'linear-gradient(135deg,rgba(201,168,76,0.1),rgba(178,34,34,0.07))', padding:'16px 20px', display:'flex', alignItems:'center', gap:12, borderBottom:'1px solid rgba(201,168,76,0.12)' }}>
                <span style={{ fontSize:'1.4rem' }}>{grp.icon}</span>
                <div>
                  <div style={{ fontFamily:"'Cinzel Decorative',serif", fontSize:'0.8rem', color:'var(--primary)' }}>{grp.group_name}</div>
                  <div style={{ fontSize:'0.66rem', color:grp.is_accent?'var(--primary-light)':'var(--text-muted)', marginTop:2 }}>{grp.sub_title}</div>
                </div>
              </div>
              {(grp.items||[]).map((item,j)=>(
                <div key={j} style={{ padding:'14px 20px', borderBottom:j<grp.items.length-1?'1px solid rgba(255,255,255,0.05)':'none' }}>
                  <div style={{ fontFamily:"'Cinzel Decorative',serif", fontSize:'0.95rem', color:'var(--primary-light)', marginBottom:4 }}>{item.t||item.time}</div>
                  <div style={{ fontSize:'0.78rem', color:'var(--text-muted)' }}>{item.n||item.name}</div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
